// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; 
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
// Los valores se inyectan por variable de entorno en Netlify según el ambiente:
//   - staging  → habitia-dev-8b512
//   - production → propit-a5831
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBiAL6j9uia6CZqceFu0BOdMr6-utBidPk",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "propit-a5831.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "propit-a5831",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "propit-a5831.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "241529496588",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:241529496588:web:67497f1f84238eb8857a29",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-3HK12Z0XX6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Exportar auth correctamente (emails de Auth en español: reset password, etc.)
const auth = getAuth(app);
auth.languageCode = "es";
export { auth };
export const db = getFirestore(app);
export const storage = getStorage(app);
/** Cloud Functions (misma región que las definidas en functions/index.js) */
export const functions = getFunctions(app, "us-central1");

// App secundaria para crear usuarios sin desloguearse
export const secondaryApp = initializeApp(firebaseConfig, "Secondary");
const secondaryAuth = getAuth(secondaryApp);
secondaryAuth.languageCode = "es";
export { secondaryAuth };
